<span (click)="isVisible = true" [ngClass]="{ invisible: !isVisible }">{{
  isVisible ? text : coverText
}}</span>
<mat-icon
  color="primary"
  (click)="copy()"
  [ngStyle]="{ display: isVisible ? 'flex' : 'none' }"
>
  content_copy
</mat-icon>
